import type { Ref, SelectHTMLAttributes } from 'react';
import classNames from 'classnames';

import { useFormFieldControl } from '@/components/atoms/FormField/FormFieldContext';
import styles from '@/components/atoms/FormField/formControl.module.scss';

export interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
    /** Marks the field invalid. Inside a FormField an `error` does this already. */
    invalid?: boolean;
    ref?: Ref<HTMLSelectElement>;
}

/** A native `<select>`; pass the `<option>`s as children. The ref reaches the element. */
export default function Select(props: SelectProps) {
    const {
        ref,
        className,
        id,
        invalid,
        'aria-describedby': ariaDescribedBy,
        ...selectProps
    } = props;
    const accessible = useFormFieldControl({
        id,
        invalid,
        'aria-describedby': ariaDescribedBy,
    });

    return (
        <select
            ref={ref}
            {...accessible}
            {...selectProps}
            className={classNames(styles.control, className)}
        />
    );
}
